<template>
  <div class="bg-white flex flex-col rounded" v-loading="fullscreenLoading">
    <div class="flex justify-between items-center mb-4">
      <div class="flex flex-1">
        <h3>{{ title }}</h3>
      </div>
      <div class="flex">
        <el-upload
          ref="uploadBackup"
          action=""
          :on-change="onChange"
          :file-list="fileList"
          :show-file-list="false"
          :auto-upload="false"
          accept=".ecocim"
        >
          <el-button type="primary" icon="el-icon-upload" slot="trigger" plain
            >Upload Backup</el-button
          >
          <!-- <el-button
            type="primary"
            style="margin-left: 10px"
            @click="showDialog = true"
            plain
            >Schedule Backup</el-button
          >
          <el-button
            type="primary"
            @click="
              () => {
                $router.push({ path: customizationPage })
              }
            "
            plain
            >Backup Settings</el-button
          > -->
          <el-button
            type="success"
            style="margin-left: 10px;"
            icon="el-icon-plus"
            @click="createBackup"
            plain
            >Create Backup</el-button
          >
          <!-- <div slot="tip" class="el-upload__tip">
            jpg/png files with a size less than 500kb
          </div> -->
        </el-upload>
      </div>
    </div>
    <hr style="margin: 0px 0px 10px 0px;" />

    <SimpleTable
      :headers="headers"
      :items="items"
      :customizationPage="customizationPage"
      :options="options"
      @download-row="download"
      @restore-row="restore"
      @remove-row="remove"
    />

    <FormDialog
      :title="'Schedule Backup'"
      :show-dialog="showDialog"
      :form="formScheduleBackup"
      @onClose="showDialogBackup(false)"
    />
  </div>
</template>

<script>
import moment from 'moment'
import SimpleTable from '@/components/dx/SimpleTable'
import formService from '@/mixins/FormService'
import formHelper from './form-helper'
import FormDialog from './FormDialog.vue'
import FileSaver from 'file-saver'

let service

export default {
  components: {
    SimpleTable,
    FormDialog
  },
  mounted() {
    this.fetchData()
    service = new formService(this, formHelper)
  },
  data() {
    return {
      fullscreenLoading: false,
      title: 'Backup and Restore',
      customizationPage: '/config/backup-restore/settings',
      apiRemove: this.$appInfo.api.version.deleteBackup,
      apiDownload: this.$appInfo.api.version.downloadBackup,
      apiBackup: this.$appInfo.api.version.backup,
      apiRestore: this.$appInfo.api.version.restore,
      apiUpload: this.$appInfo.api.version.uploadBackup,
      showDialog: false,
      items: [],
      formScheduleBackup: {
        comment: ''
      },
      fileList: [],
      headers: [
        { type: 'string', text: 'Name', value: 'name' },
        { type: 'string', text: 'Date', value: 'lastModified' },
        { type: 'string', text: 'Size', value: 'fileSize' },
        {
          type: 'string',
          text: 'Action',
          value: 'Id',
          cellTemplate: 'backupRestore'
        }
      ],
      options: {
        allowToRefetch: true
      }
    }
  },
  methods: {
    moment: function () {
      return moment()
    },
    async remove(row) {
      this.$confirm(
        'This will permanently delete this record. Continue?',
        'Are you sure',
        {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(async () => {
          try {
            await this.$axios.post(
              `${this.apiRemove}?fileName=${row.data.name}`
            )

            this.fetchData()

            this.$message({
              type: 'success',
              message: 'Delete completed'
            })
          } catch (e) {
            this.$message.error(e)
            this.fullscreenLoading = false
            console.log(e)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
        })
    },

    async fetchData() {
      try {
        this.fullscreenLoading = true
        const res = await this.$axios.get(
          this.$appInfo.api.version.existingBackup
        )
        let sortedData = res.data.sort(
          (a, b) => new Date(b.lastModified) - new Date(a.lastModified)
        )
        sortedData.forEach((x, index) => {
          x.Id = index + 1
          x.fileSize = this.formatBytes(x.fileSize)
          x.lastModified = moment(x.lastModified).format('DD-MM-YYYY HH:mm')
        })
        this.items = sortedData
        this.fullscreenLoading = false
      } catch (e) {
        this.fullscreenLoading = false
        console.log(e)
      }
    },
    async download(row) {
      try {
        this.fullscreenLoading = true
        const res = await this.$axios.get(
          `${this.apiDownload}?fileName=${row.data.name}`,
          {
            responseType: 'blob'
          }
        )

        const fileName = row.data.name
        const blob = new Blob([res.data])
        FileSaver.saveAs(blob, fileName)

        this.fullscreenLoading = false
      } catch (e) {
        this.fullscreenLoading = false
        console.log(e)
      }
    },
    async restore(row) {
      const fileName = row.data.name
      this.$confirm(`Restore data ${fileName}?`, 'Are you sure', {
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        type: 'info'
      })
        .then(async () => {
          const loading = this.$loading({
            lock: true,
            text: 'Restore process will take a few minutes',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          try {
            const params = { name: fileName }
            // await this.$axios.get(this.apiRestore, params)
            this.fetchData()
            loading.close()
            this.$message({
              type: 'success',
              message: 'Restore completed'
            })
          } catch (e) {
            loading.close()
            this.$message.error(e)
            console.log(e)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Restore canceled'
          })
        })
    },
    async onChange(file, fileList) {
      let splitExt = file.name.split('.')
      let ext = splitExt[splitExt.length - 1]
      if (!ext.includes('ecocim')) {
        return this.$message.warning(`Sorry, ${file.name} is invalid file type`)
      } else {
        this.uploadBackup(file)
      }
    },
    async uploadBackup(file) {
      try {
        this.fullscreenLoading = true
        const formData = new FormData()
        formData.append('uploadedFile', file.raw)
        await this.$axios.post(`${this.apiUpload}`, formData)
        this.$message.success(`Successfully upload backup file`)
        this.fetchData()
        this.fullscreenLoading = false
      } catch (e) {
        this.$message.error(`Failed to upload backup file ${file.name}`)
        this.fetchData()
        this.fullscreenLoading = false
        console.log(e)
      }
    },
    async createBackup() {
      this.$confirm('Backup current data?', 'Are you sure', {
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        type: 'info'
      })
        .then(async () => {
          const loading = this.$loading({
            lock: true,
            text: 'Backup process will take a few minutes',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          try {
            const backupName = this.formatDate(new Date())
            const params = { name: backupName }
            await this.$axios.get(this.apiBackup, params)
            this.fetchData()
            loading.close()
            this.$message({
              type: 'success',
              message: 'Backup completed'
            })
          } catch (e) {
            loading.close()
            this.$message.error(e)
            console.log(e)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Backup canceled'
          })
        })
    },

    showDialogBackup(val) {
      this.showDialog = val
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = '' + d.getHours(),
        minute = '' + d.getMinutes(),
        second = '' + d.getSeconds()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      if (hour.length < 2) hour = '0' + hour
      if (minute.length < 2) minute = '0' + minute
      if (second.length < 2) second = '0' + second

      return [year, month, day, hour, minute, second].join('_')
    }
  }
}
</script>
